import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "./../index";
import { Button, Modal, Form, Input, Radio } from "antd";
import Ithoigian from "./../../../assets/suc-khoe-vang/thoigiancho.png";
import Close from "./../../../assets/suc-khoe-vang/dateclose.png";

const WaitingTime = (props) => {
  const { vat, setVAT } = useContext(AuthContext);
  // const [vat, setVAT] = useState(null);
  const [typeId, setTypeId] = useState(1);
  const [form] = Form.useForm();
  const formRef = React.createRef();

  useEffect(async () => {
    let dataVAT = JSON.parse(localStorage.getItem("vatskv"));
    if (dataVAT) {
      setVAT(dataVAT);
      form.setFieldsValue(dataVAT);
    } else {
      form.resetFields();
      form.setFieldsValue({ typeId: 1 });
    }
  }, [props.isModalVisible]);

  const actionFormVAT = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        // console.log(values);
        let vat = {
          ...values,
          typeName: +values?.typeId === 1 ? "Cá nhân" : "Doanh nghiệp",
        };
        localStorage.setItem("vatskv", JSON.stringify(vat));
        setVAT(vat);
        props.handleCancel();
      })
      .catch((err) => {
        console.error("err:", err);
      });
  };

  return (
    <div style={{ fontSize: 14 }}>
      <Modal
        className="custom-modal-antd"
        style={{
          maxWidth: "100%",
          margin: 0,
          verticalAlign: "bottom",
          padding: 0,
          maxHeight: "90%",
        }}
        centered={true}
        footer={false}
        closable={false}
        open={props.isModalVisible}
        onCancel={props.handleCancel}
        maskStyle={{ background: "#000000", opacity: 0.8 }}
      >
        <div>
          <div
            style={{
              borderBottom: "1px solid #dddddd",
              fontWeight: 600,
              padding: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "90%", textAlign: "center", fontSize: 18}}>
              Thời gian chờ
            </div>
            <div>
              <img
                onClick={() => props.handleCancel()}
                src={Close}
                alt="Global Care"
                width={20}
              />
            </div>
          </div>
          <div style={{padding: 10}}>
            <img src={Ithoigian} style={{width:'100%'}} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default WaitingTime;
